import { CREATE_APPLE_PAYMENT_LINK_REL } from './constants'

export const createApplePaySessionLinkSelector = (state) =>
  state.links.filter((link) => link.Rel === CREATE_APPLE_PAYMENT_LINK_REL)[0]
export const getRiskData = (state) => state.riskData
